import { Product_View } from "@/api/hasura/generated/graphql"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { IProduct } from "./product.types"
import { Product } from "./product"

export type ProductRaw = Product_View

export const ProductParser: IParser<IProduct, ProductRaw> = {
  toDomain: (data: ProductRaw) => {
    try {
      if (!data.id) throw new Error("Product id is undefined")
      if (!data.code) throw new Error("Product code is undefined")
      if (!data.name) throw new Error("Product name is undefined")
      if (!data.display_name) {
        throw new Error("Product display name is undefined")
      }

      return new Product(
        data.id,
        data.code,
        data.name,
        data.display_name,
        data.duration_value ?? 0,
        !!data.active_for_enrolment,
        !!data.active_for_renewal,
        !!data.recommend_for_enrolment,
        !!data.recommend_for_renewal,
        !!data.requires_smart_charging,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
